import { render, staticRenderFns } from "./MediaSizeInput.vue?vue&type=template&id=324c7a66&"
import script from "./MediaSizeInput.vue?vue&type=script&lang=ts&"
export * from "./MediaSizeInput.vue?vue&type=script&lang=ts&"
import style0 from "./MediaSizeInput.vue?vue&type=style&index=0&id=324c7a66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports